// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__pXEFJ","mobileAboutContainer":"About_mobileAboutContainer__dEC1h","aboutContentContainer":"About_aboutContentContainer__b0qz6"};